import { Stack, Typography } from "@mui/material";

interface NotFoundProps {
  title?: string;
  description?: string;
}

const NotFound = ({ title, description }: NotFoundProps) => {
  return (
    <Stack flex={1} height="100%" sx={{ backgroundColor: "#DDEAFD" }}>
      <Stack flex={1} padding={3} alignItems="center" justifyContent="center">
        <img
          alt="Not found"
          width="400"
          style={{
            mixBlendMode: "multiply",
          }}
          src="https://firebasestorage.googleapis.com/v0/b/menuapp-b44a8.appspot.com/o/assets%2Fnot-found-or-available.png?alt=media&token=7c74f7d0-5646-4cf1-9b03-ac2110dce4c0"
        />
      </Stack>
      <Stack
        flex={1}
        padding={3}
        gap={1}
        sx={{
          borderTopLeftRadius: 32,
          borderTopRightRadius: 32,
          backgroundColor: "white",
        }}
      >
        <Typography variant="h1" textAlign="center">
          {title ? title : "No disponible"}
        </Typography>
        <Typography variant="body1" textAlign="center">
          {description ? description : "El menú al que intentas acceder, no está disponible o no posees suficientes permisos"}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default NotFound;
